import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

interface SurfaceData {
  year: number;
  detected: number;
  converted: number;
}

interface Props {
  data: SurfaceData[];
  loading?: boolean;
}

export const SurfaceComparisonChart = ({ data, loading }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={5}>Superficie Detectada vs Convertida (ha)</Title>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="detected" fill="#faad14" name="Detectada" />
          <Bar dataKey="converted" fill="#52c41a" name="Convertida" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
